import type { ReactNode } from 'react';
import { PageContainer } from '../PageContainer/PageContainer';
import { TemplateSection } from './Section';

type Block = { title: ReactNode; content: ReactNode };

export type SalaryTemplateProps = {
  /** A PageHeader stating the basis and period (monthly gross, estimates excluded). */
  header: ReactNode;
  /** DistributionBars with the middle half highlighted. */
  distribution?: ReactNode;
  /** A Readout with the typical figure, range and sample. */
  readout?: ReactNode;
  /** An InlineAlert linking the method. */
  methodNote?: ReactNode;
  /** Tables by level and by region; hide a breakdown when its sample is too small. */
  tables?: Block[];
  /** JobCards that state pay. */
  jobs?: Block;
  className?: string;
};

/** Salary pages for a role, comparison and methodology. Sample sizes on every figure. */
export function SalaryTemplate({
  header,
  distribution,
  readout,
  methodNote,
  tables = [],
  jobs,
  className,
}: SalaryTemplateProps) {
  return (
    <PageContainer className={className}>
      <div className="flex flex-col gap-jc-section py-jc-section">
        {header}
        <div className="grid items-start gap-jc-block lg:grid-cols-3">
          {distribution ? <div className="lg:col-span-2">{distribution}</div> : null}
          {readout}
        </div>
        {methodNote}
        {tables.map((t, i) => (
          <TemplateSection key={i} id={`breakdown-${i + 1}`} title={t.title}>
            {t.content}
          </TemplateSection>
        ))}
        {jobs ? (
          <TemplateSection id="jobs" title={jobs.title}>
            <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">{jobs.content}</div>
          </TemplateSection>
        ) : null}
      </div>
    </PageContainer>
  );
}
